import { render } from "./external-examiner-main.html?vue&type=template&id=b155f6b8&scoped=true&ts=true&external"
import script from "./external-examiner-main.ts?vue&type=script&lang=ts&external"
export * from "./external-examiner-main.ts?vue&type=script&lang=ts&external"

import "./external-examiner-main.scss?vue&type=style&index=0&id=b155f6b8&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b155f6b8"]])

export default __exports__